<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/foundation/news" class="active">Foundation</a></li>
                            <!-- <li><a routerLink="/community/news" class="active">In the Community </a></li> -->
                            <li><a routerLink="/trustees">Trustees</a></li>
                            <!-- <li><a href="javascript:void(0);" >Leicestershire Cricket Society</a></li>
                            <li><a href="javascript:void(0);">Coaching Camps</a></li>
                            <li><a routerLink="/cricket"> Mike Turner Indoor Cricket Centre</a></li>                                                                                        -->
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <div class="community-tab-list-section cf">
        <div class="container">
            <div class="community-tab-detail">
                <ul>
                    <li><a routerLink="/foundation/about-us" class="courses-name active" id="about-us">About Us</a></li>
                    <li><a routerLink="/foundation/clubs" class="courses-name " id="club-cricket">Club</a></li>
                    <li><a routerLink="/foundation/communitys" class="courses-name " id="community">Community</a></li>
                    <li><a routerLink="/foundation/women-and-girls" class="courses-name " id="women-girls">Women and Girls</a></li>
                    <li><a routerLink="/foundation/schools" class="courses-name " id="schools">Schools</a></li>  
                    <li><a routerLink="/foundation/governance" class="courses-name " id="governanc">Governance</a></li>    
                    <li><a routerLink="/foundation/safeguarding" class="courses-name " id="volunteering">Safeguarding</a></li>                                                
                </ul>
            </div>
        </div>
    </div>
    <div class="community-tab-content-box-section cf">
        <div class="community-tab-content-outer about-tab course-main-content active" id="about-us-content">
            <div class="container">
                <div class="community-tab-about cf">
                    <div class="community-tab-about-top" *ngFor="let abouts of aboutList?.data?.aboutus">
                        <div class="community-tab-about-top-left">
                            <div class="academy-our-strategy-top-titel">
                                <h2 class="titel-name">{{abouts?.title}}</h2>
                            </div>
                            <div class="academy-our-strategy-top-content" [innerHTML]="abouts?.description">
                            </div>
                        </div>
                        <div class="community-tab-about-top-right" *ngIf="abouts?.community_aboutus_images">
                            <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideaboutimageConfig">
                                <div ngxSlickItem class="community-tab-about-top-right-image slide" *ngFor="let images of abouts?.community_aboutus_images">
                                    <img [src]="images?.image">
                                </div>
                            </ngx-slick-carousel>
                        </div>
                    </div>
                    <div class="academy-graduates-bottom cf" *ngIf="communitystaffList?.length > 0">
                        <div class="academy-our-strategy-top-titel">
                            <h2 class="titel-name">Community Team</h2>
                         </div>
                        <div class="sub-committe-detail cf">
                            <ngx-slick-carousel class="carousel" slickModal="slick-carousel"[config]="slideourstaffConfig">
                                <div ngxSlickItem class="player-staff-box slide" *ngFor="let staff of communitystaffList">
                                    <img [src]="staff?.image" >
                                    <div class="player-staff-box-overlay">
                                        <h4>{{staff?.name}}</h4>
                                        <p>{{staff?.designation}}</p>
                                    </div> 
                                </div>
                            </ngx-slick-carousel>
                        </div>
                    </div>
                    <div class="community-report">
                        <!-- <iframe src="https://player.flipsnack.com?hash=Qzg3QkVDQkJEQzkraDNxdjBzaWhwOA==" width="100%" height="480" seamless="seamless" scrolling="no" frameBorder="0" allowFullScreen allow="autoplay; clipboard-read; clipboard-write"></iframe> -->
                        <iframe src="https://player.flipsnack.com?hash=Qzg3QkVDQkJEQzkrZHRtNDk4aWhwOA==" width="100%" height="480" seamless="seamless" scrolling="no" frameBorder="0" allowFullScreen allow="autoplay; clipboard-read; clipboard-write"></iframe>
                    </div>
                    <div class="community-report-link">
                        <p> <a href="https://www.flipsnack.com/C87BECBBDC9/lccc-equality-diversity-2024-rep/full-view.html" target="_blank">Click Here to Read our 2024 Report</a> </p>
                        
                    </div>
                    <div class="commercial-contact-us-section cf" *ngIf="textList">
                        <div class="titel-box">
                          <h2 class="titel-name">Contact us</h2>
                        </div>
                        <div class="commercial-contact-content" [innerHTML]="textList?.description">
                        </div>
                    </div>
                </div>
            </div>
            <div class="commercial-bottom-contact-form" style="background-image: url(assets/images/contact-commercial-bg.jpg);">
                <div class="container">
                    <div class="commercial-bottom-contact-detail">
                        <form class="commercialform " #contactusForm="ngForm" (ngSubmit)="clubContactus(contactusForm)" [ngClass]="{'success': contactSuccess}">
                            <http-message types="success" [data]="contactSuccess" class="err-msg-block">
                            </http-message>
                            <http-message [type]="'error'" [data]="contactError" *ngIf="contactError"
                               class="err-msg-block"></http-message>
                               <div class="join-register-right-box">
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="first_name" [(ngModel)]="contactRequest.first_name"
                                        class="app-group">
                                        <input appFieldInput class="register-style" placeholder="First Name" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="last_name" [(ngModel)]="contactRequest.last_name"
                                        class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Last Name" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="email" [(ngModel)]="contactRequest.email"
                                        class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Email Address" type="text">
                                    </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="mobile_number" [(ngModel)]="contactRequest.mobile_number"
                                        class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Mobile No" type="number">
                                </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="company_name" [(ngModel)]="contactRequest.company_name"
                                        class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Company Name" type="text">
                                </app-form-field>
                                </div>
                                <div class="join-register-right-box-input half">
                                    <app-form-field validation="required" name="type_of_event" [(ngModel)]="contactRequest.type_of_event"
                                        class="app-group">
                                        <input appFieldInput class="register-style" placeholder="Type of event" name="type_of_event" type="text" >
                                </app-form-field>
                                </div>
                                <div class="join-register-right-box-input full">
                                    <app-form-field validation="required" name="message" [(ngModel)]="contactRequest.message"
                                        class="app-group">
                                        <textarea appFieldInput name="message" form="usrform" class="register-style" placeholder="Message">Message</textarea>
                                    </app-form-field>
                                </div>
                            </div>
                            <div class="join-register-right-box">
                                <div class="join-register-btn"><button id="reg_button" type="submit">Submit</button></div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="commercial-bottom-contact-overlay"></div>
            </div>
        </div>
        <div class="community-tab-content-outer course-main-content" id="club-cricket-content">
            <div class="container">
                <div class="community-tab-content-detail">                    
                    <div>
                        <div class="community-tab-content-box">
                            <div class="titel-box">
                                <h2 class="titel-name">Club</h2>
                            </div>
                            <!--<div class="community-tab-text">
                                <p>Our Vision is to "Inspire people to choose and enjoy a lifelong involvement in cricket" and Club Cricket is an integral part of making this happen. We support the development needs of affiliated clubs regardless of the level they play at.</p>
                                <p>Interested in playing?For individuals looking to play please click here to find your local cricket club. You could also visit the Playing section of our website where you will find more information about different formats of the game that might be of interest.</p>
                            </div>-->
                        </div>
                        <div class="club-travelling-bottom" *ngIf="clubList?.data?.length > 0">
                            <ul class="directions-faq">
                                <li class="faq-title " [ngClass]="{ active: i == 0 }" *ngFor="let details of clubList?.data; let i = index">
                                    <a class="faq-add" href="javascript:void(0);">
                                        <h3>{{details?.title}}<span><img src="assets/images/fox-white.png"></span></h3>
                                    </a>
                                    <div class="faq-content">
                                        <div class="faq-content-description cf" [innerHTML]="details?.description"></div>
                                        <div class="faq-content-inner cf" *ngIf="details?.community_club_detail?.length > 0">
                                            <div class="faq-content-inner-details cf" *ngFor="let detailsinn of details?.community_club_detail">
                                                <h3>{{detailsinn?.title}}</h3>
                                                <div [innerHTML]="detailsinn?.description"></div>
                                            </div>
                                        </div>
                                        <!-- <p>The Uptonsteel County Ground is within easy reach of all Leicester’s transport links including motorway, 
                                            bus and rail connections across the country<br>
                                        </p>
                                        <p><br></p>
                                        <p><a href="https://www.choosehowyoumove.co.uk/" target="_blank"><u>Choose How You Move</u></a>&nbsp;- the one-stop-shop for travel information in Leicester &amp; Leicestershire. Use their journey planner to help you explore the different travel options that are available for your visit.</p> -->
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>                  
                </div>
            </div>
        </div> 
        <div class="community-tab-content-outer course-main-content" id="community-content">
            <div class="container">
                <div class="community-tab-content-detail" *ngIf="communityList?.data?.length > 0">                    
                    <div>
                        <div class="community-tab-content-box">
                            <div class="titel-box">
                                <h2 class="titel-name">Community</h2>
                            </div>
                            <div class="community-tab-text" [innerHTML]="communityList?.data[0]?.description">
                                <p>Fun, fast, and free – that’s why we like cycling in Leicester & Leicestershire. Cycling is a quick and easy way to get around, with a network of cycleways, dedicated lanes, paths and routes providing links across Leicester & Leicestershire. You can park your bike in one of the cycle racks available at the Curzon Road or Park Hill Drive entrances.</p>
                            </div>
                        </div>
                        <div class="club-travelling-bottom">
                            <ul class="directions-faq">
                                <li class="faq-title " [ngClass]="{ active: i == 0 }" *ngFor="let details of communityList?.data[0]?.community_detail; let i = index">
                                    <a class="faq-add" href="javascript:void(0);">
                                        <h3>{{details?.title}}<span><img src="assets/images/fox-white.png"></span></h3>
                                    </a>
                                    <div class="faq-content" [innerHTML]="details?.description"> 
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>                  
                </div>
            </div>
        </div>
        <div class="community-tab-content-outer course-main-content" id="women-girls-content">
            <div class="container">
                <div class="community-tab-content-detail">                    
                    <div>
                        <div class="community-tab-content-box">
                            <div class="titel-box">
                                <h2 class="titel-name">Women and Girls</h2>
                            </div>
                            <!--<div class="community-tab-text" [innerHTML]="communitys?.description">
                                <p>Fun, fast, and free – that’s why we like cycling in Leicester & Leicestershire. Cycling is a quick and easy way to get around, with a network of cycleways, dedicated lanes, paths and routes providing links across Leicester & Leicestershire. You can park your bike in one of the cycle racks available at the Curzon Road or Park Hill Drive entrances.</p>
                            </div>-->
                        </div>
                        <div class="club-travelling-bottom" *ngIf="womensList?.data?.length > 0">
                            <ul class="directions-faq">
                                <li class="faq-title " [ngClass]="{ active: i == 0 }" *ngFor="let details of womensList?.data; let i = index">
                                    <a class="faq-add" href="javascript:void(0);">
                                        <h3>{{details?.title}}<span><img src="assets/images/fox-white.png"></span></h3>
                                    </a>
                                    <div class="faq-content" [innerHTML]="details?.description"> 
                                      
                                    </div>
                                </li>
                               
                            </ul>
                        </div>
                    </div>                  
                </div>
            </div>
        </div>
        <div class="community-tab-content-outer course-main-content" id="schools-content">
            <div class="container">
                <div class="community-tab-content-detail">
                    <div class="community-tab-content-box">
                        <div class="titel-box">
                            <h2 class="titel-name">Schools</h2>
                        </div>
                    </div>
                    <div class="club-travelling-bottom" *ngIf="schoolList?.data?.length > 0">
                        <ul class="directions-faq">
                            <li class="faq-title" [ngClass]="{ active: i == 0 }" *ngFor="let details of schoolList?.data; let i = index">
                                <a class="faq-add" href="javascript:void(0);">
                                    <h3>{{details?.title}}<span><img src="assets/images/fox-white.png"></span></h3>
                                </a>
                                <div class="faq-content" [innerHTML]="details?.description"> 
                                      
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="community-tab-content-outer course-main-content" id="governanc-content">
            <div class="container">
                <div class="community-tab-content-detail">
                    <div *ngFor="let governance of governanceList?.data">
                        <div class="community-tab-content-box">
                            <div class="titel-box">
                                <h2 class="titel-name">{{governance?.title}}</h2>
                            </div>
                            <div class="community-tab-text" [innerHTML]="governance?.description">
                                <p>Fun, fast, and free – that’s why we like cycling in Leicester & Leicestershire. Cycling is a quick and easy way to get around, with a network of cycleways, dedicated lanes, paths and routes providing links across Leicester & Leicestershire. You can park your bike in one of the cycle racks available at the Curzon Road or Park Hill Drive entrances.</p>
                            </div>
                        </div>
                        <div class="club-travelling-bottom governanc-detail" *ngIf="governance?.community_detail?.length > 0">
                            <ul class="directions-faq">
                                <li class="faq-title active" [ngClass]="{ active: i == 0 }" *ngFor="let details of governance?.community_detail; let i = index">
                                    <a class="faq-add" href="javascript:void(0);">
                                        <h3>{{details?.title}}<span><img src="assets/images/fox-white.png"></span></h3>
                                    </a>
                                    <div class="faq-content" [innerHTML]="details?.description">
                                        <p>The Uptonsteel County Ground is within easy reach of all Leicester’s transport links including motorway, 
                                            bus and rail connections across the country<br>
                                        </p>
                                        <p><br></p>
                                        <p><a href="https://www.choosehowyoumove.co.uk/" target="_blank"><u>Choose How You Move</u></a>&nbsp;- the one-stop-shop for travel information in Leicester &amp; Leicestershire. Use their journey planner to help you explore the different travel options that are available for your visit.</p>
                                    </div>
                                </li>  
                            </ul>
                            <div class="membership-top-box membership-image">
                                <a href="javascript:void(0)"><img src="assets/images/lccc-fox-logo.svg"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="community-tab-content-outer course-main-content" id="volunteering-content">
            <div class="container">
                <div class="community-tab-content-detail">
                    <div class="titel-box"><h2 class="titel-name">Safeguarding</h2></div>
                    <div class="new-single-content">
                        <h3>Join the Running Foxes Volunteer Team</h3>
                        <p>06 December 2021</p>
                        <div>
                           <p><span><font color="#418840"><b>Leicestershire County Cricket Club is looking to recruit a brand new group of dedicated volunteers to join the Foxes Family to form part of our match day and major event day team of helpers.</b></font></span></p>
                           <p><span>Over the course of 2022 the club expects to welcome over 60,000 spectators to the Uptonsteel County Ground and to help deliver an unforgettable experience our Running Foxes Volunteer Team will play a huge role in the delivery of events at Leicester’s Premier Outdoor Venue.</span></p>
                           <p><span>Our volunteer roles do not require any formal experience or qualifications, full training will be provided. Our team will say the first hello and final goodbye, with roles as diverse as the people we are looking for. They will be meet &amp; greeters, venue preppers, ticketing assistants, fan zone engagement staff, outer venue helpers plus a range of other roles.</span></p>
                           <p><span>In order to participate in the volunteering programme, applicants must be:</span></p>
                           <p><span>-<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span>At least 16 years of age as of 1 April 2022</span></p>
                           <p><span>-<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span>&nbsp;A brilliant communicator</span></p>
                           <p><span>-<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span>Eligible to work in the United Kingdom without any additional immigration approvals</span></p>
                           <p><span>-<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span>Available to volunteer for a minimum of Four Match/Event Days between April-September</span></p>
                           <blockquote>
                              <p><span>Leicestershire County Cricket Club’s Head of Community, Mark Barber said:&nbsp;<i>“Cricket is synonymous with Volunteers, they are the heartbeat of cricket and many major events, engaging with visitors attending and helping to provide the best experience possible.</i></span></p>
                              <p><span><i>“We want to show the vibrant culture and diversity that Leicester has through our events and Volunteering at the Uptonsteel County Ground will be a unique opportunity to contribute to the community and experience, so I'd encourage the people of the Leicestershire to submit an application and come and join the Foxes Family”.</i></span></p>
                           </blockquote>
                           <p><span>&nbsp;</span></p>
                           <p><span>&nbsp;</span></p>
                           <p align="center"><span><b>Safeguarding Timeline</b></span></p>
                           <div>
                              <table class="MsoTableGrid" border="1" cellspacing="0" cellpadding="0">
                                 <tbody>
                                    <tr>
                                        <td width="332">
                                          <p align="center"><span>DECEMBER 2021: APPLICATIONS OPEN</span></p>
                                        </td>
                                    </tr>
                                 </tbody>
                              </table>
                              <br>
                           </div>
                           <p><span></span></p>
                           <div>
                              <table class="MsoTableGrid" border="1" cellspacing="0" cellpadding="0">
                                 <tbody>
                                    <tr>
                                       <td width="332">
                                          <p align="center"><span>FEBRUARY 2022: APPLICATIONS CLOSE</span></p>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                              <br>
                           </div>
                           <p><span></span></p>
                           <div>
                              <table class="MsoTableGrid" border="1" cellspacing="0" cellpadding="0">
                                 <tbody>
                                    <tr>
                                       <td width="332">
                                          <p align="center"><span>MARCH 2022: INTERVIEWS START</span></p>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                              <br>
                           </div>
                           <p><span></span></p>
                           <div >
                              <table class="MsoTableGrid" border="1" cellspacing="0" cellpadding="0">
                                 <tbody>
                                    <tr>
                                       <td width="332">
                                          <p align="center"><span>APRIL 2022: ROLES OFFERED &amp; TRAINING DELIVERED</span></p>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                              <br>
                           </div>
                           <p><span></span></p>
                           <div>
                              <table class="MsoTableGrid" border="1" cellspacing="0" cellpadding="0">
                                 <tbody>
                                    <tr>
                                       <td width="332">
                                          <p align="center"><span>APRIL 2022: EVENTS START</span></p>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                           <p><span>&nbsp;</span></p>
                           <p><span><b><font color="#418840">Running Foxes Volunteer Team</font><font color="#418840">&nbsp;Volunteer Benefits Include:</font></b></span></p>
                           <p class="MsoListParagraphCxSpFirst"><span>·<span>&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></span>Running Foxes Volunteer Team event day uniform</p>
                           <p class="MsoListParagraphCxSpMiddle"><span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span>Running Fox Pin Badge</span></p>
                           <p class="MsoListParagraphCxSpMiddle"><span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span>Complimentary tickets for friends and family to selected event days</span></p>
                           <p class="MsoListParagraphCxSpMiddle"><span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span>Invitation to the Grassroots Cricket Awards (OSCA) Dinner at the Uptonsteel County Ground in 2022</span></p>
                           <p class="MsoListParagraphCxSpLast"><span>·<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></span><span>Individual employment references on request</span></p>
                           <p><span>Not only will you be part of the delivery of some incredible events but you will form new friendships along the way too!</span></p>
                           <p><span>Applications are now open to join the Running Foxes Volunteer Team&nbsp;for 2022 and you can apply by completing our Running Foxes Volunteer Team&nbsp;application form&nbsp;<a href="https://forms.office.com/pages/responsepage.aspx?id=uvUFEUqw9kSGHLnNKWe2zngaWRD3_jpOvMs614DrvBFUMFBQTzZOM0FVUzJOT0U2N1VISUNKVzEyUC4u&amp;web=1&amp;wdLOR=c4D55BA17-B83A-4F34-B79E-08239673B85E"><b><span>HERE</span></b></a>.</span></p>
                        </div>
                     </div>
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->